/*
* 项目类型*/
const projectTypeArray = [
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '探索者1v1计划'},
    {value: 55, label: '其他'},
]

const projectTypeAllArray = [
    {value: '', label: '全部',},
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '探索者1v1计划'},
    {value: 55, label: '其他'},
]

const projectTypeZeroArray = [
    {value: 0, label: '全部',},
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '探索者1v1计划'},
    {value: 55, label: '其他'},
]


/*
* 年级*/
const gradeList = [  // 年级列表
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）',
    '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业'
]//学生年级

export default {
    projectTypeArray,
    projectTypeAllArray,
    projectTypeZeroArray,
    gradeList
}